/**
 * For updating tags on customer
 * Is hooked up via Vercel endpoint, with access to Admin API
 */
class CustomerForm extends HTMLFormElement {
  constructor() {
    super();

    this.submit = this.querySelector('button[type="submit"]');

    this.errorElement = this.querySelector('[data-error]');
    this.successElement = this.querySelector('[data-success]');

    this.addEventListener('submit', this.handleSubmit);
  }

  /**
   * @param {SubmitEvent} event
   */
  async handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this);

    try {
      this.submit.disabled = true;

      const response = await fetch(this.action, {
        method: this.method,
        headers: {
          'X-Customer-Id': window.themeVariables.customer.id,
          'X-Verification-Hmac-SHA256': window.themeVariables.customer.signature,
        },
        body: formData,
      });

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      this.successElement.hidden = false;
      this.successElement.textContent = window.themeVariables.strings.customer.update.tags;

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      this.submit.disabled = false;
      this.errorElement.hidden = false;
      this.errorElement.textContent = error.message;

      throw error;
    }
  }
}

if (!window.customElements.get('customer-form')) {
  window.customElements.define('customer-form', CustomerForm, { extends: 'form' });
}

class CreateCustomerForm extends HTMLFormElement {
  constructor() {
    super();

    this.addEventListener('change', this.handleChange);
  }

  handleChange() {
    const formData = new FormData(this);
    const customTags = formData.getAll('tags[]');

    if (!this.querySelector('input[name="customer[tags]"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'customer[tags]';

      this.insertAdjacentElement('beforeend', input);
    }

    const tagsInput = this.querySelector('input[name="customer[tags]"]');
    tagsInput.value = customTags.join(',');
  }
}

if (!window.customElements.get('create-customer-form')) {
  window.customElements.define('create-customer-form', CreateCustomerForm, { extends: 'form' });
}



